/**
 * „Umgesetzt am … · Nachschau offen“ im Backlog (Paul 29.10.2026).
 *
 * Tickets bleiben nach dem Deploy offen, bis die Nachverfolgung belegt, dass
 * der Fix wirkt. Ohne diesen Hinweis sieht die Liste aus, als sei kaum etwas
 * umgesetzt. Das Datum liefert das Backend (Kommentar „Auf Prod seit …“).
 */
export type Umsetzung = {
  state: string
  umgesetzt?: boolean
  umgesetzt_am?: string | null
  wirkt_nicht?: boolean
}

export type UmsetzungHinweis = { text: string; titel: string; wirktNicht: boolean }

/** "2026-10-28" → "28.10." — ohne Zeitzone, das Datum ist schon ein Kalendertag. */
function tagMonat(iso: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso)
  return m ? `${m[3]}.${m[2]}.` : iso
}

export function umsetzungHinweis(item: Umsetzung): UmsetzungHinweis | null {
  if (!item.umgesetzt || item.state === "closed") return null
  const seit = item.umgesetzt_am ? ` ${tagMonat(item.umgesetzt_am)}` : ""
  if (item.wirkt_nicht) {
    return {
      text: `Umgesetzt${seit} · wirkt nicht`,
      titel: "Auf Prod, aber die Nachpruefung hat einen Rueckfall gefunden",
      wirktNicht: true,
    }
  }
  return {
    text: `Umgesetzt${seit} · Nachschau offen`,
    titel: "Auf Prod. Die Nachverfolgung schliesst das Ticket, sobald ein echter Fall zeigt, dass es wirkt.",
    wirktNicht: false,
  }
}
